import { RegExpUtility } from "../text/RegExpUtility";
import { DateHelper } from "./DateHelper";
import { DateMath } from "./DateMath";
import { DateRange } from "./DateRange";
import { DateRepeat } from "./DateRepeat";

export class DateParser
{ 
  static readonly nowRegex = /now/;
  static readonly todayRegex = /today/;
  static readonly yesterDayRegex = /yesterday/;
  static readonly dayRegex = /(1|2|3)?\d(st|nd|rd|th|\.)/;
  static readonly yearRegex = /\d\d\d\d/;
  static readonly monthRegex = /(jan)|(feb)|(mar)|(apr)|(may)|(jun)|(jul)|(aug)|(sep)|(oct)|(nov)|(dec)/i;
  static readonly hoursRegex = /[0-2]?[0-9]:[0-5][0-9]h?/;
  static readonly seasonRegex = /(spring|autumn|summer|winter)/i;

  static parseTime( value:string, alternative:[number,number] = [0,0])
  {
    if ( ! value || ! DateParser.hoursRegex.test( value ) )
    {
      return alternative;
    } 

    let parsed = /(\d+)\:(\d+)/.exec( value );

    if ( parsed.length !=  3 )
    {
     // console.log( "Filter Incorrect time:", value, parsed.length, parsed );
      return alternative;
    }

    let hours   = parseInt( parsed[ 1 ] );
    let minutes = parseInt( parsed[ 2 ] );

    return [ hours, minutes ];    
  }

  static regex3x2 = /(\d\d?)(?:\.|\||\/)(\d\d?)(?:\.|\||\/)(\d\d)/;

  static parse( value:string, dateRange:DateRange = null, monthBeforeDay:boolean = false ):DateRange[]
  {
    var oneDate = DateParser.parse3x2( value, monthBeforeDay );

    if ( oneDate )
    {
      return [ DateRange.forDay( oneDate ) ];
    }

    if ( DateRepeat.isRepeatType( value ) )
    {
      var dates = DateRepeat.getDatesOf( value, dateRange );
      var dateRanges = dates.map( d => DateRange.forDay( d ) );
      return dateRanges;
    }

    return [ DateParser.parseInternationalEnglish( value ) ];
  }

  static parse3x2( value:string, monthBeforeDay:boolean = false ):Date
  {
    let result = DateParser.regex3x2.exec( value );

    if ( ! result )
    {
      return null;
    }

    let day   = parseInt( result[ 1 ] );
    let month = parseInt( result[ 2 ] );
    let year  = 2000 + parseInt( result[ 3 ] );

  

    if ( monthBeforeDay )
    {
      let buffer = day;

      day = month;
      month = buffer;
    }

    let date = DateHelper.createYMD( year, month, day, 3, 0, 0 );

    return date;
  }

  static parseRange( value:string, standardTime:[number,number] = [20,0] ):DateRange
  {
    return this.parseInternationalEnglish( value, standardTime );
  }

  static seasonToDate( season:string, type:"metreo"|"astro"|"mid", year:number = null, hours:number = 12, minutes:number = 0 )
  {
    year = year || new Date().getFullYear();

    let seasonData:{matcher:RegExp, metreo:number[], astro:number[], mid:number[] }[] =    
    [
      { 
        matcher:/(spring|frühling|frue?hling)/i,
        metreo:[20,3], 
        astro:[1,3],
        mid:[15,4]
      },

      { 
        matcher:/(summer|sommer)/i,
        metreo:[21,6], 
        astro:[1,6],
        mid:[15,7]
      },

      { 
        matcher:/(autumn|herbst)/i,
        metreo:[23,9], 
        astro:[1,9],
        mid:[15,10]
      },

      { 
        matcher:/(winter)/i,
        metreo:[21,12], 
        astro:[1,12],
        mid:[15,12]
      }
    ]
    ;

    let seasonInfo = seasonData.find( s => s.matcher.test( season ) );

    let dayMonth = seasonInfo[ type ];

    return DateHelper.createYMD( year, dayMonth[ 1 ], dayMonth[ 0 ], hours, minutes, 0 );
  }

  static parseInternationalEnglish( value:string, standardTime:[number,number] = [20,0] ):DateRange
  {
    if ( /every|several/i.test( value ) )
    {
      return null;
    }
    
    if ( DateParser.nowRegex.test( value ) )
    {
      return DateRange.now();
    }

    if ( DateParser.todayRegex.test( value ) )
    {
      return DateRange.today();
    }

    if ( DateParser.yesterDayRegex.test( value ) )
    {
      return DateRange.yesterday();
    }

    if ( DateParser.seasonRegex.test( value ) )
    {
      let yearResult = RegExpUtility.cutout( value, DateParser.yearRegex );
      value = yearResult[ 0 ];
      let year = parseInt( yearResult[ 1 ] );
      let season = RegExpUtility.cutout( value, DateParser.seasonRegex )[ 1 ];

      return DateRange.create( this.seasonToDate( season, "astro", year ) );
    }

    let yearResult  = RegExpUtility.cutout( value, DateParser.yearRegex );    
    value = yearResult[ 0 ];

    let dayResult   = RegExpUtility.cutout( value, DateParser.dayRegex );    
    value = dayResult[ 0 ];
  
    let monthResult = RegExpUtility.cutout( value, DateParser.monthRegex );    
    value = monthResult[ 0 ];

    let hoursResult = RegExpUtility.cutout( value, DateParser.hoursRegex );  
    value = hoursResult[ 0 ];

    let dayResult2    = dayResult;
    let monthResult2  = monthResult;
    let yearResult2   = yearResult;
    let hoursResult2  = hoursResult;

    let isRange = /-/.test( value );

    if ( isRange )
    {
      yearResult2 = RegExpUtility.cutout( value, DateParser.yearRegex );         
      value = yearResult2[ 0 ];
      yearResult2 = yearResult2[ 1 ] ? yearResult2 : yearResult;
  
      dayResult2  = RegExpUtility.cutout( value, DateParser.dayRegex );    
      value = dayResult2[ 0 ];
      dayResult2 = dayResult2[ 1 ] ? dayResult2 : dayResult;
    
      monthResult2 = RegExpUtility.cutout( value, DateParser.monthRegex );    
      value = monthResult2[ 0 ];
      monthResult2 = monthResult2[ 1 ] ? monthResult2 : monthResult;

      hoursResult2 = RegExpUtility.cutout( value, DateParser.hoursRegex );    
      value = hoursResult2[ 0 ];
      hoursResult2 = hoursResult2[ 1 ] ? hoursResult2 : hoursResult;
      
    }

    let startDate = this.parseDateFromString( dayResult[ 1 ], monthResult[ 1 ], yearResult[ 1 ], hoursResult[ 1 ], standardTime );    
    let endDate   = this.parseDateFromString( dayResult2[ 1 ], monthResult2[ 1 ], yearResult2[ 1 ], hoursResult2[ 1 ], standardTime );   


    let range = DateRange.create( startDate, endDate );

    //console.log( "Parsed range for filters:", inputValue, ">>", range );
    return range;
    
  }
  
  static getWeekDayIndex( value:string )
  {
    value = value.trim();

    if ( /^\d$/.test( value ) )
    {
      return parseInt( value );
    }

    if ( /mon/i.test( value ) )
    {
      return 1;
    }

    if ( /tue/i.test( value ) )
    {
      return 2;
    }

    if ( /wed/i.test( value ) )
    {
      return 3;
    }

    if ( /thu/i.test( value ) )
    {
      return 4;
    }


    if ( /fri/i.test( value ) )
    {
      return 5;
    }

    if ( /sat/i.test( value ) )
    {
      return 6;
    }

    if ( /sun/i.test( value ) )
    {
      return 0;
    } 

    return -1;



  }

  static getMonthIndex( value:string )
  {
    let monthRegexResult = DateParser.monthRegex.exec( value );

    if ( ! monthRegexResult )
    { 
      return 0;
    }

    let month = 0;

    for ( let i = 0; i < 12; i++ )
    {
      if ( monthRegexResult[ i + 1 ] )
      {
        month = i;
        break;
      }  
    }

    return month;
  }

  static parseDateFromString( day:string, month:string, year:string, time:string, standardTime:[number,number]=[0,0] )
  {
    let yearValue  = parseInt( year );
    let dayValue   = parseInt( day.replace( /(st|nd|rd|th|\.)/, "" ) );
    let monthValue = DateParser.getMonthIndex( month );

    let timeValue = this.parseTime( time, standardTime );

    //console.log( "Creating date for filter:", time, ">>", timeValue );

    return new Date( yearValue, monthValue, dayValue, timeValue[ 0 ], timeValue[ 1 ] );
  }


}